import { render, staticRenderFns } from "./TabelaGestaoCertificacao.vue?vue&type=template&id=066ddbd6&lang=pug"
import script from "./TabelaGestaoCertificacao.vue?vue&type=script&lang=js"
export * from "./TabelaGestaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaGestaoCertificacao.vue?vue&type=style&index=0&id=066ddbd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports